<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="11" stroke="#14142B" stroke-width="2"/>
		<path d="M9 9L15 15" stroke="#14142B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M9 15L15 9" stroke="#14142B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>

<script>
  export default {
    name: 'DeactivateIcon'
  };
</script>